meedy.controller('meedy.opinionConfirmedController', ['$scope', '$state', '$stateParams', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.opinionModel',
  function ($scope, $state, $stateParams,  $translate, objectHelper, applicationModel, userModel, opinionModel) {

    function setData() {
    }

    function setFilters() {
    }

    function setListeners() {
      $scope.$on('$destroy', function (event) {
        applicationModel.viewReady = false;
      });

    }

    function setActions() {
    }

    function configureInterface() {
      var breadcrumbItems = [];
      applicationModel.setBreadcrumbItems(breadcrumbItems);
      applicationModel.setTitleBar('T.MEEDY.MODULE.TITLE.OPINION.OPINION');
    }

    function initialize() {
      applicationModel.viewReady = true;
    }

    setData();
    setFilters();
    setListeners();
    setActions();
    configureInterface();
    initialize();
  }
]);
